<div class="appliedFilter">
    <span class="Spacebox__r-medium Spacebox__l-small Spacebox__tb-tiny"
        genTooltip
        [tooltipText]="filter.tooltip"
        [tooltipPosition]="'BOTTOM'"
        [tooltipShow]="true">
      {{filter.translatedName}}
    </span>
    <span class="icon__dls-error fs7 pointer" (click)="clearFilter(filter)"></span>
</div>  